module.exports = __webpack_public_path__ + "static/05-adfd026f6f91008cb520b6f2a89c835e.jpg";